// extracted by mini-css-extract-plugin
export default {"Haricot":"#01A92B","alertContent":"Gc336e1","alertIconWrapper":"Gb744eb","alertIcon":"Gd994b4","alertText":"G0afeec G0aa891","creditCopy":"Gc7ebaa G5cce1c"};